import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target instanceof HTMLElement) {
        target.scrollIntoView();
        target.focus({ preventScroll: true });
      }
      return;
    }

    window.scrollTo(0, 0);

    // Keep keyboard focus in the planner shell; content pages get focus on the main landmark.
    if (pathname === "/") {
      return;
    }

    const main = document.querySelector("main");
    if (main instanceof HTMLElement) {
      main.focus({ preventScroll: true });
    }
  }, [pathname, hash]);

  return null;
}
